var AnalyticsPlatformName;
(function (AnalyticsPlatformName) {
    AnalyticsPlatformName["Desktop"] = "Desktop";
    AnalyticsPlatformName["Mobile"] = "Mobile";
    AnalyticsPlatformName["Plugin"] = "Plugin";
    AnalyticsPlatformName["Web"] = "Web";
})(AnalyticsPlatformName || (AnalyticsPlatformName = {}));
function getPlatformName(localWindow = window) {
    if (localWindow.isMobileAppWebView) {
        return AnalyticsPlatformName.Mobile;
    }
    if (localWindow.electronPreload) {
        return AnalyticsPlatformName.Desktop;
    }
    return AnalyticsPlatformName.Web;
}

export { AnalyticsPlatformName, getPlatformName };
